import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouse as SchemaDeliveryWarehouse } from '../schemas/DeliveryWarehouse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDeliveryWarehouseContentType = '' as const;
export type GetDeliveryWarehouseRequest = void;
export type GetDeliveryWarehouseResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaDeliveryWarehouse;
    };
};
export type GetDeliveryWarehouseResponseSuccess = GetDeliveryWarehouseResponses['200']['application/json'];
export type GetDeliveryWarehouseSearchParams = undefined;
export type GetDeliveryWarehousePathParameters = {
    warehouse_id: string;
};
export const GetDeliveryWarehouseUrl = '/delivery/warehouse/{warehouse_id}' as const;
export const GetDeliveryWarehouseMethod = 'GET' as const;
export const getGetDeliveryWarehouseUrl = (params: GetDeliveryWarehousePathParameters) =>
    GetDeliveryWarehouseUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetDeliveryWarehousePathParameters) =>
        String(params[param])
    );
